import errorimage from '../Components/Common/FilesRelevent/pdf.png'

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const urlValidation = (value) => {
  const urlPattern = /^https:\/\/([\w\d\-\.]+)\.([a-z\.]{2,6})([\w\-\/\.]*)?([\S]*)?$/i;
  return urlPattern.test(value);
};

const today = new Date().toISOString().split("T")[0];

const Today = new Date();
const formattedDate = Today.toISOString().split('T')[0];

const formatDate1122 = (inputDate) => {
  const date = new Date(inputDate);
  
  if (isNaN(date.getTime())) {
    console.error('Invalid date:', inputDate);
    return null;  
  }

  const month = (date.getMonth() + 1).toString().padStart(2, '0');  
  const day = date.getDate().toString().padStart(2, '0');        
  const year = date.getFullYear();                                  
  return `${year}-${month}-${day}`;                                
};

const handleImageError11 = (e) => {
  e.target.src = errorimage;
};


export {handleImageError11,  scrollToTop, urlValidation, today , formattedDate, formatDate1122};
